import React from 'react'
const path = require('path')
interface InterfaceMDXText {
  file: string
  wrapperClass?: string
}

export const MDXContent = ({ file, wrapperClass = '' }: InterfaceMDXText) => {
  const components = {
    wrapper: props => (
      <div
        className={wrapperClass}
        {...props}
        onClick={() => {
          console.log(props)
        }}
      />
    )
  }

  const Text = require('images/' + file).default
  return <Text components={components} />
}
